var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBigbusiness1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 251,
    viewBox: "0 0 250 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_75_6700)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.125,
    width: 250,
    height: 250,
    rx: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("line", {
    x1: 17.9658,
    y1: 119.593,
    x2: 17.9658,
    y2: -21.9221,
    stroke: "url(#paint0_linear_75_6700)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 52.9658,
    y1: 119.593,
    x2: 52.9658,
    y2: -21.9221,
    stroke: "url(#paint1_linear_75_6700)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 88.9658,
    y1: 119.593,
    x2: 88.9658,
    y2: -21.9221,
    stroke: "url(#paint2_linear_75_6700)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 124.966,
    y1: 119.593,
    x2: 124.966,
    y2: -21.9221,
    stroke: "url(#paint3_linear_75_6700)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160.966,
    y1: 119.593,
    x2: 160.966,
    y2: -21.9221,
    stroke: "url(#paint4_linear_75_6700)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 195.966,
    y1: 119.593,
    x2: 195.966,
    y2: -21.9221,
    stroke: "url(#paint5_linear_75_6700)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 231.966,
    y1: 119.593,
    x2: 231.966,
    y2: -21.9222,
    stroke: "url(#paint6_linear_75_6700)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -4.37114e-8,
    y1: 18.454,
    x2: 258.387,
    y2: 18.454,
    stroke: "url(#paint7_linear_75_6700)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -4.37114e-8,
    y1: 77.454,
    x2: 258.387,
    y2: 77.454,
    stroke: "url(#paint8_linear_75_6700)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -4.37114e-8,
    y1: 47.454,
    x2: 258.387,
    y2: 47.454,
    stroke: "url(#paint9_linear_75_6700)"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 16.625,
    width: 87,
    height: 87,
    rx: 43.5,
    fill: "url(#paint10_linear_75_6700)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.1284 49.625H64.6024C66.1673 49.6273 67.6674 50.2506 68.7731 51.358C69.8789 52.4654 70.4999 53.9663 70.4999 55.5312V71.9375C71.8923 71.9375 73.2277 71.3844 74.2122 70.3998C75.1968 69.4152 75.7499 68.0799 75.7499 66.6875V49.814C75.7499 47.1802 73.7812 44.8947 71.0879 44.669C70.6955 44.6371 70.3029 44.608 69.9102 44.5815C69.4672 43.728 68.7983 43.0126 67.9765 42.5132C67.1547 42.0139 66.2115 41.7499 65.2499 41.75H62.6249C61.6633 41.7499 60.7201 42.0139 59.8983 42.5132C59.0765 43.0126 58.4076 43.728 57.9647 44.5815C57.5709 44.6077 57.1772 44.6375 56.7869 44.669C54.1584 44.8912 52.2194 47.0735 52.1284 49.625ZM62.6249 44.375C61.9287 44.375 61.261 44.6516 60.7688 45.1438C60.2765 45.6361 59.9999 46.3038 59.9999 47H67.8749C67.8749 46.3038 67.5984 45.6361 67.1061 45.1438C66.6138 44.6516 65.9461 44.375 65.2499 44.375H62.6249Z",
    fill: "#A4D143"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.25 55.5312C44.25 53.7183 45.72 52.25 47.5312 52.25H64.5938C66.4067 52.25 67.875 53.72 67.875 55.5312V75.2188C67.875 77.03 66.405 78.5 64.5938 78.5H47.5312C46.661 78.5 45.8264 78.1543 45.2111 77.5389C44.5957 76.9236 44.25 76.089 44.25 75.2188V55.5312ZM61.0255 63.5707C61.2432 63.2988 61.3439 62.9515 61.3055 62.6052C61.2671 62.259 61.0927 61.9422 60.8207 61.7245C60.5488 61.5068 60.2015 61.4061 59.8552 61.4445C59.509 61.4829 59.1922 61.6573 58.9745 61.9293L54.6415 67.3473L53.0525 65.76C52.8037 65.5282 52.4746 65.4019 52.1346 65.4079C51.7946 65.4139 51.4701 65.5517 51.2297 65.7922C50.9892 66.0326 50.8514 66.3571 50.8454 66.6971C50.8394 67.0371 50.9657 67.3662 51.1975 67.615L53.8225 70.24C53.953 70.3705 54.1097 70.472 54.2821 70.5379C54.4545 70.6038 54.6389 70.6325 54.8233 70.6223C55.0076 70.612 55.1876 70.563 55.3517 70.4785C55.5158 70.3939 55.6602 70.2757 55.7755 70.1315L61.0255 63.569V63.5707Z",
    fill: "#83A735"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 16.625,
    width: 87,
    height: 87,
    rx: 43.5,
    stroke: "url(#paint11_linear_75_6700)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.527 212.125V206.12H28.6794V203.977H19.527V199.334H29.0143V197.169H17.1161V212.125H19.527ZM33.2173 212.125V205.897C33.2173 203.91 33.9986 202.861 35.896 202.861C37.5479 202.861 38.2176 203.598 38.2176 205.183V206.165H40.6062V204.714C40.6062 202.615 39.5123 200.807 36.9898 200.807C34.7129 200.807 33.5075 202.236 33.1726 204.022H33.0164V201.03H30.8064V212.125H33.2173ZM47.7012 212.348C51.005 212.348 53.3266 210.719 53.3266 208.352V208.152H50.9157V208.33C50.9157 209.647 49.9558 210.406 47.6342 210.406C45.0671 210.406 44.0179 209.268 43.9286 207.125H53.3489C53.4159 206.79 53.4382 206.477 53.4382 206.075C53.4382 202.705 51.0943 200.807 47.6566 200.807C44.0402 200.807 41.674 203.129 41.674 206.589C41.674 210.295 44.0626 212.348 47.7012 212.348ZM47.6119 202.705C49.9781 202.705 51.1613 203.687 51.1613 205.741V205.785H43.9509C44.0849 203.799 45.1564 202.705 47.6119 202.705ZM60.8247 212.348C64.1284 212.348 66.45 210.719 66.45 208.352V208.152H64.0392V208.33C64.0392 209.647 63.0793 210.406 60.7577 210.406C58.1905 210.406 57.1414 209.268 57.0521 207.125H66.4724C66.5393 206.79 66.5617 206.477 66.5617 206.075C66.5617 202.705 64.2177 200.807 60.78 200.807C57.1637 200.807 54.7975 203.129 54.7975 206.589C54.7975 210.295 57.186 212.348 60.8247 212.348ZM60.7354 202.705C63.1016 202.705 64.2847 203.687 64.2847 205.741V205.785H57.0744C57.2083 203.799 58.2798 202.705 60.7354 202.705ZM74.5932 212.125V205.897C74.5932 203.91 75.3745 202.861 77.272 202.861C78.9239 202.861 79.5935 203.598 79.5935 205.183V206.165H81.9821V204.714C81.9821 202.615 80.8883 200.807 78.3658 200.807C76.0888 200.807 74.8834 202.236 74.5486 204.022H74.3923V201.03H72.1823V212.125H74.5932ZM89.0771 212.348C92.3809 212.348 94.7025 210.719 94.7025 208.352V208.152H92.2916V208.33C92.2916 209.647 91.3318 210.406 89.0102 210.406C86.443 210.406 85.3938 209.268 85.3046 207.125H94.7248C94.7918 206.79 94.8141 206.477 94.8141 206.075C94.8141 202.705 92.4702 200.807 89.0325 200.807C85.4162 200.807 83.0499 203.129 83.0499 206.589C83.0499 210.295 85.4385 212.348 89.0771 212.348ZM88.9878 202.705C91.3541 202.705 92.5372 203.687 92.5372 205.741V205.785H85.3269C85.4608 203.799 86.5323 202.705 88.9878 202.705ZM101.442 211.12C103.964 211.12 105.46 209.915 105.862 208.241H106.018V210.964C106.018 213.442 105.103 214.134 102.58 214.134C100.214 214.134 99.2763 213.531 99.2763 211.924H96.8877C96.8877 214.603 99.1647 216.143 102.446 216.143C106.085 216.143 108.406 214.558 108.406 210.83V201.03H106.196V203.799H106.062C105.661 201.856 103.919 200.807 101.598 200.807C98.2271 200.807 96.1734 202.883 96.1734 205.964C96.1734 209.044 98.1378 211.12 101.442 211.12ZM98.6066 205.964C98.6066 203.687 99.9683 202.906 102.29 202.906C104.634 202.906 106.018 203.866 106.018 205.741V206.053C106.018 208.018 104.678 209.044 102.223 209.044C99.946 209.044 98.6066 208.241 98.6066 205.964ZM113.048 199.736V197.169H110.637V199.736H113.048ZM113.048 212.125V201.03H110.637V212.125H113.048ZM120.526 212.348C123.652 212.348 125.705 211.12 125.705 209.044C125.705 207.214 124.5 206.321 121.866 205.986L119.299 205.629C117.624 205.406 117.178 205.093 117.178 204.223C117.178 203.173 117.892 202.727 119.924 202.727C122.379 202.727 123.049 203.419 123.049 204.736V204.87H125.437V204.803C125.437 202.169 123.384 200.807 119.991 200.807C116.575 200.807 114.812 202.191 114.812 204.133C114.812 205.986 116.084 206.879 118.182 207.147L121.218 207.549C122.803 207.772 123.339 208.062 123.339 208.977C123.339 209.96 122.692 210.406 120.526 210.406C118.205 210.406 117.334 209.937 117.334 208.486V208.308H114.923V208.375C114.923 210.942 116.955 212.348 120.526 212.348ZM134.722 212.125V209.96H132.713C131.329 209.96 130.704 209.603 130.704 208.241V203.04H134.722V201.03H130.704V198.597H128.315V201.03H126.44V203.04H128.315V208.375C128.315 211.076 129.789 212.125 132.177 212.125H134.722ZM138.641 212.125V205.897C138.641 203.91 139.422 202.861 141.32 202.861C142.972 202.861 143.641 203.598 143.641 205.183V206.165H146.03V204.714C146.03 202.615 144.936 200.807 142.413 200.807C140.137 200.807 138.931 202.236 138.596 204.022H138.44V201.03H136.23V212.125H138.641ZM150.803 212.348C153.326 212.348 155.089 211.232 155.67 209.357H155.826V212.125H158.036V205.383C158.036 202.727 156.451 200.807 152.924 200.807C149.397 200.807 147.299 202.705 147.299 205.227V205.317H149.687V205.227C149.687 203.598 150.692 202.928 152.745 202.928C154.866 202.928 155.67 203.575 155.67 205.406V206.053L150.625 206.589C148.437 206.834 147.053 207.727 147.053 209.446C147.053 211.277 148.504 212.348 150.803 212.348ZM149.464 209.29C149.464 208.419 150.067 208.129 151.317 207.973L155.67 207.482C155.67 209.669 153.973 210.607 151.451 210.607C150.067 210.607 149.464 210.183 149.464 209.29ZM167.465 212.125V209.96H165.456C164.072 209.96 163.447 209.603 163.447 208.241V203.04H167.465V201.03H163.447V198.597H161.059V201.03H159.183V203.04H161.059V208.375C161.059 211.076 162.532 212.125 164.92 212.125H167.465ZM171.384 199.736V197.169H168.973V199.736H171.384ZM171.384 212.125V201.03H168.973V212.125H171.384ZM179.287 212.348C182.992 212.348 185.47 210.004 185.47 206.589C185.47 203.129 182.992 200.807 179.287 200.807C175.603 200.807 173.125 203.129 173.125 206.589C173.125 210.004 175.603 212.348 179.287 212.348ZM179.287 210.205C176.608 210.205 175.492 208.933 175.492 206.589C175.492 204.223 176.608 202.928 179.287 202.928C181.988 202.928 183.104 204.223 183.104 206.589C183.104 208.933 181.988 210.205 179.287 210.205ZM189.63 212.125V206.634C189.63 204.223 190.724 202.973 193.158 202.973C195.457 202.973 196.394 204.022 196.394 206.098V212.125H198.805V205.45C198.805 202.883 197.287 200.807 194.207 200.807C191.394 200.807 189.921 202.593 189.586 204.468H189.43V201.03H187.22V212.125H189.63Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_75_6700",
    x1: 19.4661,
    y1: 182.688,
    x2: 19.4661,
    y2: 48.8354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFC6D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFC6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_75_6700",
    x1: 54.4661,
    y1: 182.688,
    x2: 54.4661,
    y2: 48.8354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFC6D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFC6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_75_6700",
    x1: 90.4661,
    y1: 182.688,
    x2: 90.4661,
    y2: 48.8354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFC6D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFC6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_75_6700",
    x1: 126.466,
    y1: 182.688,
    x2: 126.466,
    y2: 48.8354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFC6D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFC6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_75_6700",
    x1: 162.466,
    y1: 182.688,
    x2: 162.466,
    y2: 48.8354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFC6D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFC6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_75_6700",
    x1: 197.466,
    y1: 182.688,
    x2: 197.466,
    y2: 48.8354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFC6D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFC6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_75_6700",
    x1: 233.466,
    y1: 182.688,
    x2: 233.466,
    y2: 48.8353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFC6D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFC6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_75_6700",
    x1: 269.17,
    y1: 18.954,
    x2: -9.24119,
    y2: 18.9542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#E8FDBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#E8FDBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_75_6700",
    x1: 269.17,
    y1: 77.954,
    x2: -9.24119,
    y2: 77.9542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#E8FDBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#E8FDBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_75_6700",
    x1: 269.17,
    y1: 47.954,
    x2: -9.24119,
    y2: 47.9542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#E8FDBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#E8FDBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_75_6700",
    x1: 60,
    y1: 16.125,
    x2: 62.6601,
    y2: 133.657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3FEDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.508459,
    stopColor: "#E8FDBE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_75_6700",
    x1: 60,
    y1: 16.125,
    x2: 60,
    y2: 104.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDFCA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8FDBE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_75_6700"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.125,
    width: 250,
    height: 250,
    rx: 10,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigbusiness1);
export default __webpack_public_path__ + "static/media/bigbusiness1.fd1b405966c7ba7696ff4f1074263c85.svg";
export { ForwardRef as ReactComponent };